import { __decorate, __awaiter, __param } from 'tslib';
import { DatePipe, CommonModule } from '@angular/common';
import { Injectable, Inject, Optional, SkipSelf, NgModule } from '@angular/core';
import { FormControl, Validators, FormBuilder, FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { Storage, IonicStorageModule } from '@ionic/storage';
import { RxReactiveFormsModule } from '@rxweb/reactive-form-validators';
import { APP_PARAMETER } from '@wlp/ui-bs-parameter';
import { ConfigService, SpeViewNAccountProxy, SpeNOpenAccountProxy, SpeNAccountProxy, SpeJCashOutProxy, SpeJCheckEventProxy, SpeJFundsProxy, SpeNPaymentVoucherProxy, SpeNAccountsProxy, SpeNTransactionApprovalProxy, UiPxCashOutModule } from '@wlp/ui-px-cashout';
import { BaseService, DocumentValidator, UfService, CreditCardFlagService, ErrorMessageService, PrintService, BanksService } from '@wlp/ui-bs-util';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import * as moment_ from 'moment';

let AccountDataService = class AccountDataService extends BaseService {
    constructor(storage, configService, speViewNAccountProxy) {
        super(storage, configService);
        this.storage = storage;
        this.configService = configService;
        this.speViewNAccountProxy = speViewNAccountProxy;
    }
    /**
     * retorna os dados pessoais da conta usando o uuid como parametro
     * @param uuidAccount
     */
    getAccountPaymentPerson(uuid) {
        return this.speViewNAccountProxy.getAccountPaymentPerson(uuid);
    }
};
AccountDataService.ctorParameters = () => [
    { type: Storage },
    { type: ConfigService },
    { type: SpeViewNAccountProxy }
];
AccountDataService = __decorate([
    Injectable()
], AccountDataService);

class AddCardResponse {
}

let AddCardService = class AddCardService extends BaseService {
    constructor(storage, formBuilder, ufService, creditCardFlagService, configService, speNOpenAccountProxy, speNAccountProxy, errorMessageService) {
        super(storage, configService);
        this.storage = storage;
        this.formBuilder = formBuilder;
        this.ufService = ufService;
        this.creditCardFlagService = creditCardFlagService;
        this.configService = configService;
        this.speNOpenAccountProxy = speNOpenAccountProxy;
        this.speNAccountProxy = speNAccountProxy;
        this.errorMessageService = errorMessageService;
        this.errorMessages = {
            nameCard: [
                {
                    type: 'minlength',
                    message: 'CASH_OUT.ADD_CARD.FORM.CARD_FORM.NAME_CARD.MESSAGE.MIN_LENGTH',
                    param: { minLength: 6 }
                },
                {
                    type: 'required',
                    message: 'CASH_OUT.ADD_CARD.FORM.CARD_FORM.NAME_CARD.MESSAGE.REQUIRED'
                },
                {
                    type: 'maxlength',
                    message: 'CASH_OUT.ADD_CARD.FORM.CARD_FORM.NAME_CARD.MESSAGE.MAX_LENGTH',
                    param: { minLength: 100 }
                }
            ],
            cpf: [
                { type: 'required', message: 'CASH_OUT.ADD_CARD.FORM.CARD_FORM.CPF.MESSAGE.REQUIRED' },
                { type: 'cpfNotValid', message: 'CASH_OUT.ADD_CARD.FORM.CARD_FORM.CPF.MESSAGE.CPF_NOT_VALID' },
            ],
            numberCard: [
                {
                    type: 'pattern',
                    message: 'CASH_OUT.ADD_CARD.FORM.CARD_FORM.NUMBER_CARD.MESSAGE.PATTERN'
                },
                {
                    type: 'required',
                    message: 'CASH_OUT.ADD_CARD.FORM.CARD_FORM.NUMBER_CARD.MESSAGE.REQUIRED'
                },
                {
                    type: 'maxlength',
                    message: 'CASH_OUT.ADD_CARD.FORM.CARD_FORM.NUMBER_CARD.MESSAGE.MAX_LENGTH',
                    param: { maxLength: 16 }
                }
            ],
            validityMonth: [
                {
                    type: 'pattern',
                    message: 'CASH_OUT.ADD_CARD.FORM.CARD_FORM.VALIDITY_MONTH.MESSAGE.PATTERN'
                },
                {
                    type: 'required',
                    message: 'CASH_OUT.ADD_CARD.FORM.CARD_FORM.VALIDITY_MONTH.MESSAGE.REQUIRED'
                },
                {
                    type: 'min',
                    message: 'CASH_OUT.ADD_CARD.FORM.CARD_FORM.VALIDITY_MONTH.MESSAGE.MIN'
                },
                {
                    type: 'max',
                    message: 'CASH_OUT.ADD_CARD.FORM.CARD_FORM.VALIDITY_MONTH.MESSAGE.MAX'
                },
                {
                    type: 'maxlength',
                    message: 'CASH_OUT.ADD_CARD.FORM.CARD_FORM.VALIDITY_MONTH.MESSAGE.MAX_LENGTH',
                    param: { maxLength: 2 }
                }
            ],
            validityYear: [
                {
                    type: 'pattern',
                    message: 'CASH_OUT.ADD_CARD.FORM.CARD_FORM.VALIDITY_YEAR.MESSAGE.PATTERN'
                },
                {
                    type: 'required',
                    message: 'CASH_OUT.ADD_CARD.FORM.CARD_FORM.VALIDITY_YEAR.MESSAGE.REQUIRED'
                },
                {
                    type: 'min',
                    message: 'CASH_OUT.ADD_CARD.FORM.CARD_FORM.VALIDITY_YEAR.MESSAGE.MIN',
                    param: {
                        min: new Date().getFullYear()
                    }
                },
                {
                    type: 'maxlength',
                    message: 'CASH_OUT.ADD_CARD.FORM.CARD_FORM.VALIDITY_YEAR.MESSAGE.MAX_LENGTH',
                    param: { maxLength: 2 }
                }
            ],
            postalCode: [
                { type: 'required', message: 'CASH_OUT.ADD_CARD.FORM.ADDRESS_FORM.POSTAL_CODE.MESSAGE.REQUIRED' },
                { type: 'minlength', message: 'CASH_OUT.ADD_CARD.FORM.ADDRESS_FORM.POSTAL_CODE.MESSAGE.MIN_LENGTH', param: { minLength: 9 } },
                { type: 'pattern', message: 'CASH_OUT.ADD_CARD.FORM.ADDRESS_FORM.POSTAL_CODE.MESSAGE.PATTERN' }
            ],
            address: [
                { type: 'required', message: 'CASH_OUT.ADD_CARD.FORM.ADDRESS_FORM.ADDRESS.MESSAGE.REQUIRED' },
                { type: 'minlength', param: { minLength: 5 }, message: 'CASH_OUT.ADD_CARD.FORM.ADDRESS_FORM.ADDRESS.MESSAGE.MIN_LENGTH' },
                { type: 'maxlength', param: { maxLength: 200 }, message: 'CASH_OUT.ADD_CARD.FORM.ADDRESS_FORM.ADDRESS.MESSAGE.MAX_LENGTH' },
            ],
            numberAddress: [
                { type: 'required', message: 'CASH_OUT.ADD_CARD.FORM.ADDRESS_FORM.NUMBER_ADDRESS.MESSAGE.REQUIRED' },
                { type: 'maxlength', param: { maxLength: 30 }, message: 'CASH_OUT.ADD_CARD.FORM.ADDRESS_FORM.NUMBER_ADDRESS.MESSAGE.MIN_LENGTH' },
            ],
            complementAddress: [
                { type: 'maxlength', param: { maxLength: 60 }, message: 'CASH_OUT.ADD_CARD.FORM.ADDRESS_FORM.COMPLEMENT_ADDRESS.MESSAGE.MAX_LENGTH' }
            ],
            neighborhood: [
                { type: 'required', message: 'CASH_OUT.ADD_CARD.FORM.ADDRESS_FORM.NEIGHBORHOOD.MESSAGE.REQUIRED' },
                { type: 'minlength', param: { minLength: 5 }, message: 'CASH_OUT.ADD_CARD.FORM.ADDRESS_FORM.NEIGHBORHOOD.MESSAGE.MIN_LENGTH' },
                { type: 'maxlength', param: { maxLength: 60 }, message: 'CASH_OUT.ADD_CARD.FORM.ADDRESS_FORM.NEIGHBORHOOD.MESSAGE.MAX_LENGTH' }
            ],
            cityAddress: [
                { type: 'required', message: 'CASH_OUT.ADD_CARD.FORM.ADDRESS_FORM.CITY_ADDRESS.MESSAGE.REQUIRED' },
                { type: 'minlength', param: { minLength: 5 }, message: 'CASH_OUT.ADD_CARD.FORM.ADDRESS_FORM.CITY_ADDRESS.MESSAGE.MIN_LENGTH' },
                { type: 'maxlength', param: { maxLength: 30 }, message: 'CASH_OUT.ADD_CARD.FORM.ADDRESS_FORM.CITY_ADDRESS.MESSAGE.MAX_LENGTH' }
            ],
            uf: [
                { type: 'required', message: 'CASH_OUT.ADD_CARD.FORM.ADDRESS_FORM.UF.MESSAGE.REQUIRED' }
            ],
            cvv: [
                { type: 'required', message: 'CASH_OUT.ADD_CARD.FORM.CARD_FORM.CVV.MESSAGE.REQUIRED' },
            ],
            country: [
            // { type: 'required', message: 'Campo obrigatório' },
            ],
        };
        this.imageFlagCard = null;
    }
    getErrorMessage() {
        return this.errorMessages;
    }
    getCardForm() {
        this.formAddCard = this.formBuilder.group({
            nameCard: new FormControl('', Validators.compose([
                Validators.minLength(6),
                Validators.maxLength(100),
                Validators.required,
            ])),
            cpf: new FormControl('', Validators.compose([
                DocumentValidator.isValidCPF,
                Validators.required,
            ])),
            numberCard: new FormControl('', Validators.compose([
                Validators.required,
                Validators.maxLength(16),
                Validators.pattern('^[0-9]*$')
            ])),
            validityMonth: new FormControl('', Validators.compose([
                Validators.required,
                Validators.maxLength(2),
                Validators.min(1),
                Validators.max(12),
                Validators.pattern('^[0-9]*$')
            ])),
            validityYear: new FormControl('', Validators.compose([
                Validators.required,
                Validators.maxLength(2),
                Validators.pattern('^[0-9]*$')
            ])),
            postalCode: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(9),
                Validators.pattern('^[a-zA-Z0-9_.+-]+$')
            ])),
            address: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(5),
                Validators.maxLength(200),
            ])),
            numberAddress: new FormControl('', Validators.compose([
                Validators.required,
                Validators.maxLength(30),
            ])),
            complementAddress: new FormControl('', Validators.compose([
                Validators.maxLength(60),
            ])),
            neighborhood: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(5),
                Validators.maxLength(60)
            ])),
            cityAddress: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(5),
                Validators.maxLength(30)
            ])),
            uf: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(2)
            ])),
            brand: new FormControl(''),
            cvv: new FormControl('', Validators.compose([
            // Validators.required,
            ])),
        });
        return this.formAddCard;
    }
    searchPostalCode(zipcode) {
        this.speNOpenAccountProxy
            .getCep(zipcode)
            .subscribe(data => this.updateAddress(data), error => this.errorMessageService.getError(error));
    }
    getUf() {
        return this.ufService.getListUf();
    }
    findCardFlag(numberCard) {
        return this.creditCardFlagService.getImageFlag(numberCard);
    }
    findCardFlagForName(nameCard) {
        return this.creditCardFlagService.getImageFlagForName(nameCard);
    }
    findNameCardFlag(numberCard) {
        return this.creditCardFlagService.getNameFlag(numberCard);
    }
    getErrorCardAdd(error) {
        this.errorMessageService.getError(error);
    }
    syncForm(addCard) {
        this.formAddCard.patchValue({
            nameCard: addCard.nameCard,
            cpf: addCard.cpf,
            numberCard: addCard.numberCard,
            validityMonth: addCard.validityMonth,
            validityYear: addCard.validityYear,
            postalCode: addCard.postalCode,
            numberAddress: addCard.numberAddress,
            address: addCard.address,
            cityAddress: addCard.cityAddress,
            neighborhood: addCard.neighborhood,
            complementAddress: addCard.complementAddress,
            uf: addCard.uf,
        });
    }
    updateAddress(address) {
        this.formAddCard.patchValue({
            address: address.logradouro.toUpperCase(),
            neighborhood: address.bairro.toUpperCase(),
            cityAddress: address.localidade.toUpperCase(),
            uf: address.uf.toUpperCase(),
        });
    }
    prepareAddCard(form) {
        const addCardResponse = new AddCardResponse();
        const data = form.getRawValue();
        addCardResponse.nameCard = data.nameCard;
        addCardResponse.cpf = data.cpf;
        addCardResponse.numberCard = data.numberCard;
        addCardResponse.validityMonth = data.validityMonth;
        addCardResponse.validityYear = data.validityYear;
        addCardResponse.postalCode = data.postalCode;
        addCardResponse.numberAddress = data.numberAddress;
        addCardResponse.address = data.address;
        addCardResponse.cityAddress = data.cityAddress;
        addCardResponse.neighborhood = data.neighborhood;
        addCardResponse.complementAddress = data.complementAddress;
        addCardResponse.uf = data.uf;
        return addCardResponse;
    }
};
AddCardService.ctorParameters = () => [
    { type: Storage },
    { type: FormBuilder },
    { type: UfService },
    { type: CreditCardFlagService },
    { type: ConfigService },
    { type: SpeNOpenAccountProxy },
    { type: SpeNAccountProxy },
    { type: ErrorMessageService }
];
AddCardService = __decorate([
    Injectable()
], AddCardService);

let BilletService = class BilletService extends BaseService {
    constructor(storage, configService, fb, speJCashOutProxy, speJCheckEventProxy, printService, paramInterface) {
        super(storage, configService);
        this.storage = storage;
        this.configService = configService;
        this.fb = fb;
        this.speJCashOutProxy = speJCashOutProxy;
        this.speJCheckEventProxy = speJCheckEventProxy;
        this.printService = printService;
        this.paramInterface = paramInterface;
        this.billetSubject$ = new BehaviorSubject(null);
        this.behaviorExtractBillet = new BehaviorSubject([]);
    }
    setBilletSubject(data) {
        this.billetSubject$.next(data);
    }
    /**
     * Criação do form billet
     */
    getBilletForm() {
        this.billetForm = this.fb.group({
            brCode: ['', Validators.compose([Validators.required, Validators.minLength(47), Validators.maxLength(60)])],
        });
        return this.billetForm;
    }
    /**
     * Criação do form billetExtract
     */
    getBilletExtractForm() {
        this.billetExtractForm = this.fb.group({
            nameBeneficiary: [''],
            brCode: [''],
            namePayer: [''],
            cpfPayer: [''],
            amountPaid: [''],
            discount: [''],
            interest: [''],
            fine: [''],
            totalPay: [''],
            datePay: [''],
            dateExpiration: [''],
            transactionIdConsult: [''],
        });
        return this.billetExtractForm;
    }
    /**
     * Criação do form billetExtract
     */
    getBilletResumeForm() {
        this.billetResumeForm = this.fb.group({
            nameBeneficiary: ['', [Validators.required]],
            bankBeneficiary: ['', [Validators.required]],
            brCode: ['', [Validators.required]],
            namePayer: ['', [Validators.required]],
            bankPayer: [''],
            cpfPayer: ['', [Validators.required]],
            amountPaid: ['', [Validators.required]],
            discount: [''],
            interest: [''],
            fine: [''],
            totalPay: ['', [Validators.required]],
            datePay: ['', [Validators.required]],
            dateExpiration: ['', [Validators.required]],
            editable: [''],
            identification: [''],
            transactionIdConsult: [''],
            maxPayment: [''],
            minPayment: [''],
            typeableLine: [''],
            dateExecution: ''
        });
        return this.billetResumeForm;
    }
    convertToDate(date) {
        if (date && typeof date === 'object' && date.constructor === Array) {
            if (date.length === 6) {
                return new Date(date[0], date[1] - 1, date[2], date[3], date[4], date[5]);
            }
            else if (date.length === 5) {
                return new Date(date[0], date[1] - 1, date[2], date[3], date[4]);
            }
            return new Date(date[0], date[1] - 1, date[2]);
        }
        return date;
    }
    formattedPipeDate(date) {
        return new DatePipe('en-US').transform(date, 'dd/MM/yyyy');
    }
    /**
     * Método responsavel por formatar os dados para o padrão adotado pelo form
     */
    formatData(data, namePayer, bankPayer, cpfPayer) {
        let dateExpiration;
        if (data && data.dueDate) {
            dateExpiration = this.convertToDate(data.dueDate);
        }
        let editable = false;
        if (data && data.tpAutcRecbtVlrDivgte) {
            editable = data.tpAutcRecbtVlrDivgte;
        }
        let identification = '';
        if (data && data.identification) {
            identification = data.identification;
        }
        const info = {
            editable: editable,
            nameBeneficiary: data.emitterName,
            bankBeneficiary: data.bankName,
            brCode: data.codeRead,
            namePayer,
            bankPayer,
            cpfPayer,
            amountPaid: data.valuePayment,
            discount: data.discountValue,
            interest: data.interestValue,
            fine: data.fineValue,
            totalPay: data.valuePayment,
            datePay: this.formattedPipeDate(new Date()),
            dateExpiration: this.formattedPipeDate(dateExpiration),
            identification: identification,
            transactionIdConsult: data.transactionIdConsult,
            maxPayment: data.maxPayment,
            minPayment: data.minPayment,
            typeableLine: data.typeableLine,
        };
        this.setBilletSubject(info);
        return info;
    }
    /**
     * Método responsavel por realizar a validação do codigo de barras
     * @param code
     */
    getBillet(code, isBarCode, uuidWhiteLabel, uuidAccountPayment) {
        let flag = false;
        if (this.paramInterface.device === 'APP' && isBarCode) {
            flag = true;
        }
        return this.speJCashOutProxy.postBillet(code, flag, uuidWhiteLabel, uuidAccountPayment);
    }
    /**
     * Método responsavel por retornar os dados sobre o resumo
     * de pagamento
     */
    getBilletResume() {
        const data = this.billetSubject$.value;
        this.billetResumeForm.patchValue(data);
        return this.billetResumeForm;
    }
    /**
     * Método reesponsavel por acionar o endpoint para salvar a transferencia e
     * encaminhar os dados para tela de extrato
     */
    saveBillet(info, uuidWhiteLabel, uuidAccount, token) {
        const data = {
            linePayment: info.brCode,
            typeableLine: info.typeableLine,
            identification: info.identification,
            transactionIdConsult: info.transactionIdConsult,
            value: info.totalPay,
            operationValue: info.totalPay,
            uuidAccountPayment: uuidAccount,
            uuidWhiteLabel: uuidWhiteLabel,
            dueDate: info.dueDate,
            codeAuthorization: token,
            dateExecution: info.dateExecution
        };
        this.businessBilletExtract = info;
        this.behaviorExtractBillet.next(this.businessBilletExtract);
        return this.speJCashOutProxy.postBilletConfirm(data);
    }
    /**
     * Método responsavel por retornar os dados sobre o comprovantes
     * de pagamento
     */
    getBilletExtract() {
        const data = this.billetSubject$.value;
        this.billetExtractForm.patchValue(data);
        return this.billetExtractForm;
    }
    /**
     * Método responsavel por gerar o comprovante em uma nova aba
     */
    print(html, css) {
        this.printService.print(html, css);
    }
    /**
     * @description Método responsavel por validar o saldo para pagamento
     */
    validateOperation(uuidWhiteLabel, uuidAccount, value) {
        return __awaiter(this, void 0, void 0, function* () {
            let sendingBody;
            let validateResponse;
            sendingBody = {
                codeOperation: '112',
                uuidAccountPayment: uuidAccount,
                uuidWhiteLabel: uuidWhiteLabel,
                valueOperation: value,
            };
            yield this.speJCheckEventProxy
                .validateOperation(sendingBody)
                .toPromise()
                .then((res) => {
                validateResponse = res;
            })
                .catch((err) => err);
            let response = !!validateResponse ? validateResponse : null;
            return Promise.resolve(response);
        });
    }
    /**
     * @description Método fomata o valor de string e retorna um float
     */
    formatValue(value) {
        let dataValue = value.replace(/\./g, '');
        let dataValue2 = dataValue.replace(',', '.');
        return parseFloat(dataValue2);
    }
    getListBillet() {
        return this.behaviorExtractBillet;
    }
    /**
     * Método responsavel por criar o formulario para conter os dados de compensação do boleto
     * @returns
     */
    createFormLiquidation() {
        return this.fb.group({
            uuidWhiteLabel: ['', Validators.compose([Validators.required])],
            codeAuthorization: ['', Validators.compose([Validators.required])],
            uuidTransactionRechargeBillet: ['', Validators.compose([Validators.required])],
        });
    }
    /**
     * Método responsavel por realizar a compensação do boleto
     * @param uuidAccountPayment
     * @param form
     */
    liquidation(uuidAccountPayment, form) {
        return this.speJCashOutProxy.postLiquidation(uuidAccountPayment, form);
    }
};
BilletService.ctorParameters = () => [
    { type: Storage },
    { type: ConfigService },
    { type: FormBuilder },
    { type: SpeJCashOutProxy },
    { type: SpeJCheckEventProxy },
    { type: PrintService },
    { type: undefined, decorators: [{ type: Inject, args: [APP_PARAMETER,] }] }
];
BilletService = __decorate([
    Injectable(),
    __param(6, Inject(APP_PARAMETER))
], BilletService);

class ExtractDigitalAccountResponse {
}

let ExtractDigitalAccountService = class ExtractDigitalAccountService extends BaseService {
    constructor(speJFundsProxy, errorMessageService, configService, storage) {
        super(storage, configService);
        this.speJFundsProxy = speJFundsProxy;
        this.errorMessageService = errorMessageService;
        this.configService = configService;
        this.storage = storage;
    }
    getStatement(uuidWhiteLabel, uuidAccount, dateInitial, dateEnd) {
        const initial = this.formatDateToString(dateInitial);
        const end = this.formatDateToString(dateEnd);
        return this.speJFundsProxy
            .getCheckStatement(uuidWhiteLabel, uuidAccount, initial, end)
            .pipe(map(res => this.prepareExtract(res)));
    }
    getAllStatement(operationDescription, uuidTransactionGroup, limit, page) {
        return this.speJFundsProxy.getAllStatement(operationDescription, uuidTransactionGroup, limit, page)
            .pipe(map(res => res));
    }
    getStatementCard(uuidWhiteLabel, uuidAccount, dateInitial, dateEnd) {
        const initial = this.formatDateToString(dateInitial);
        const end = this.formatDateToString(dateEnd);
        return this.speJFundsProxy
            .getCheckStatementCard(uuidWhiteLabel, uuidAccount, initial, end)
            .pipe(map(res => this.prepareExtract(res)));
    }
    getErroMessage(err) {
        return this.errorMessageService.getError(err);
    }
    valueDisplayCreditOrDebit(extractDigitalAccount) {
        return !!extractDigitalAccount.credit ? extractDigitalAccount.credit : extractDigitalAccount.debit;
    }
    showIsBalance(typeStatement) {
        return Number(typeStatement) === 0;
    }
    showIsCreditOrDebit(typeStatement) {
        return Number(typeStatement) > 0;
    }
    isCredit(typeStatement) {
        return Number(typeStatement) === 1;
    }
    prepareExtract(listDataStatement) {
        let listExtract = [];
        listDataStatement
            .forEach(data => listExtract.push(this.mountExtractDigital(data)));
        return listExtract;
    }
    mountExtractDigital(dataStatementResponse) {
        const extractDigitalAccount = new ExtractDigitalAccountResponse();
        extractDigitalAccount.uuid = dataStatementResponse.uuid;
        extractDigitalAccount.transactionId = dataStatementResponse.transactionId;
        extractDigitalAccount.category = 'Outros';
        extractDigitalAccount.description = dataStatementResponse.description;
        extractDigitalAccount.icon = 'grid-outline';
        extractDigitalAccount.typeStatement = dataStatementResponse.typeStatement;
        extractDigitalAccount.balance = dataStatementResponse.balance;
        extractDigitalAccount.credit = dataStatementResponse.credit;
        extractDigitalAccount.debit = dataStatementResponse.debit;
        extractDigitalAccount.dateRegister = dataStatementResponse.dateRegister;
        extractDigitalAccount.operationDescription = dataStatementResponse.operationDescription;
        extractDigitalAccount.groupTransactionDetailsList = dataStatementResponse.groupTransactionDetailsList;
        extractDigitalAccount.uuidTransactionGroup = dataStatementResponse.uuidTransactionGroup;
        return extractDigitalAccount;
    }
};
ExtractDigitalAccountService.ctorParameters = () => [
    { type: SpeJFundsProxy },
    { type: ErrorMessageService },
    { type: ConfigService },
    { type: Storage }
];
ExtractDigitalAccountService = __decorate([
    Injectable()
], ExtractDigitalAccountService);

let ExtractService = class ExtractService extends BaseService {
    constructor(storage, configService, paymentService) {
        super(storage, configService);
        this.storage = storage;
        this.configService = configService;
        this.paymentService = paymentService;
    }
    /**
     * retorna uma transaction usando o id como parametro
     * @param transationId
     */
    getTransaction(transationId) {
        return this.paymentService.findTransactionIdConsult(transationId);
    }
    /**
     * retorna uma transaction usando o id como parametro
     * @param uuidAccount
     */
    getAllTransactions(uuidAccount) {
        return this.paymentService.findAllAccountPayment(uuidAccount);
    }
    /**
     * Retorna uma transação passando o uuidAccount, e o periodo como parametro
     * @param uuidAccount
     */
    getTransactionsByPeriod(uuidAccount, startDate, endDate) {
        return this.paymentService.findPeriodByAccountPayment(uuidAccount, startDate, endDate);
    }
    getTransactionsByPeriodAndTypeVoucher(uuidAccount, typeVoucher, startDate, endDate) {
        return this.paymentService.findPeriodByAccountPaymentAndTypeVoucher(uuidAccount, typeVoucher, startDate, endDate);
    }
    getTransactionsByPeriodAndAccountDestination(uuidAccount, accountDestination, startDate, endDate) {
        return this.paymentService.findPeriodByAccountPaymentAndAccountDestination(uuidAccount, accountDestination, startDate, endDate);
    }
    getTransactionsByPeriodAndDocumentDestination(uuidAccount, documentDestination, startDate, endDate) {
        return this.paymentService.findPeriodByAccountPaymentAndAccountDestination(uuidAccount, documentDestination, startDate, endDate);
    }
};
ExtractService.ctorParameters = () => [
    { type: Storage },
    { type: ConfigService },
    { type: SpeNPaymentVoucherProxy }
];
ExtractService = __decorate([
    Injectable()
], ExtractService);

class TransferResponse {
}

const moment = moment_;
let TransferService = class TransferService extends BaseService {
    constructor(formBuilder, speJCashOutProxy, speJCheckEventProxy, speNAccountsProxy, storage, configService, errorMessageService, banksService, printService, extractService) {
        super(storage, configService);
        this.formBuilder = formBuilder;
        this.speJCashOutProxy = speJCashOutProxy;
        this.speJCheckEventProxy = speJCheckEventProxy;
        this.speNAccountsProxy = speNAccountsProxy;
        this.storage = storage;
        this.configService = configService;
        this.errorMessageService = errorMessageService;
        this.banksService = banksService;
        this.printService = printService;
        this.extractService = extractService;
        this.errorMessages = {
            document: [
                {
                    type: 'required',
                    message: 'CASH_OUT.TRANSFER_OTHER_ACCOUNT.FORM.DOCUMENTS.MESSAGE.REQUIRED',
                },
                {
                    type: 'cnpjNotValid',
                    message: 'CASH_OUT.TRANSFER_OTHER_ACCOUNT.FORM.DOCUMENTS.MESSAGE.CNPJ_NOT_VALID',
                },
                {
                    type: 'cpfNotValid',
                    message: 'CASH_OUT.TRANSFER_OTHER_ACCOUNT.FORM.DOCUMENTS.MESSAGE.CPF_NOT_VALID',
                },
            ],
            transferValue: [
                { type: 'required', message: 'CASH_OUT.TRANSFER_VALUE.FORM.VALUE_TRANSFER.MESSAGE.REQUIRED' },
                { type: 'invalid10', message: 'CASH_OUT.TRANSFER_VALUE.FORM.VALUE_TRANSFER.MESSAGE.INVALID10' },
                { type: 'invalid1', message: 'CASH_OUT.TRANSFER_VALUE.FORM.VALUE_TRANSFER.MESSAGE.INVALID1' },
            ],
            name: [
                { type: 'required', message: 'CASH_OUT.TRANSFER_OTHER_ACCOUNT.FORM.NAME.MESSAGE.REQUIRED' },
                {
                    type: 'minlength',
                    message: 'CASH_OUT.TRANSFER_OTHER_ACCOUNT.FORM.NAME.MESSAGE.MIN_LENGTH',
                    param: { minLength: 6 },
                },
                {
                    type: 'maxlength',
                    message: 'CASH_OUT.TRANSFER_OTHER_ACCOUNT.FORM.NAME.MESSAGE.MAX_LENGTH',
                    param: { maxLength: 60 },
                },
            ],
            branch: [
                { type: 'required', message: 'CASH_OUT.TRANSFER_OTHER_ACCOUNT.FORM.BRANCH.MESSAGE.REQUIRED' },
                {
                    type: 'minlength',
                    message: 'CASH_OUT.TRANSFER_OTHER_ACCOUNT.FORM.BRANCH.MESSAGE.MIN_LENGTH',
                    param: { minLength: 4 },
                },
                {
                    type: 'maxlength',
                    message: 'CASH_OUT.TRANSFER_OTHER_ACCOUNT.FORM.BRANCH.MESSAGE.MAX_LENGTH',
                    param: { maxLength: 4 },
                },
            ],
            accountNumber: [
                { type: 'required', message: 'CASH_OUT.TRANSFER_OTHER_ACCOUNT.FORM.ACCOUNT_NUMBER.MESSAGE.REQUIRED' },
                {
                    type: 'minlength',
                    message: 'CASH_OUT.TRANSFER_OTHER_ACCOUNT.FORM.ACCOUNT_NUMBER.MESSAGE.MIN_LENGTH',
                    param: { minLength: 3 },
                },
                {
                    type: 'maxlength',
                    message: 'CASH_OUT.TRANSFER_OTHER_ACCOUNT.FORM.ACCOUNT_NUMBER.MESSAGE.MAX_LENGTH',
                    param: { maxLength: 20 },
                },
            ],
            accountType: [{ type: 'required', message: 'CASH_OUT.TRANSFER_OTHER_ACCOUNT.FORM.ACCOUNT_TYPE.MESSAGE.REQUIRED' }],
            bank: [{ type: 'required', message: 'CASH_OUT.TRANSFER_OTHER_ACCOUNT.FORM.BANK.MESSAGE.REQUIRED' }],
        };
        this.behaviorTransfer = new BehaviorSubject(null);
        this.TransferFlow = new BehaviorSubject('');
        this.transferConfirmation = new BehaviorSubject(null);
    }
    /**
     * @description Método registra o objeto com os dados já preenchidos no fluxo de transferência
     */
    setTransfer(form) {
        this.behaviorTransfer.next(this.prepareForm(form));
    }
    /**
     * @description Método registra no objeto apenas o nome e o documento  para o fluxo de transferência por TED
     */
    setTransferOtherAccount(form) {
        let data = form.getRawValue();
        let dataTransfer = new TransferResponse();
        dataTransfer.document = data.document;
        dataTransfer.name = data.name;
        dataTransfer.transferValue = '';
        dataTransfer.bank = '';
        dataTransfer.bankCode = '';
        dataTransfer.branch = '';
        dataTransfer.accountNumber = '';
        dataTransfer.dateExecution = '';
        dataTransfer.showRepeatOptions = false;
        dataTransfer.frequency = '';
        dataTransfer.occurrences = '';
        dataTransfer.accountType = '';
        dataTransfer.date = '';
        dataTransfer.typeTransfer = 'TED';
        dataTransfer.uuidAccountPaymentDestination = '';
        dataTransfer.uuidWhiteLabelDestination = '';
        this.behaviorTransfer.next(dataTransfer);
    }
    /**
     * @description Método retorna o objeto com os dados já preenchidos no fluxo de transferência
     */
    getTransfer() {
        return this.behaviorTransfer.asObservable();
    }
    /**
     * @description Método registra o tipo de transferência está sendo feita
     */
    setTransferFlow(transferType) {
        this.TransferFlow.next(transferType);
    }
    /**
     * @description Método retorna o tipo de transferência está sendo feita
     */
    getTransferFlow() {
        return this.TransferFlow;
    }
    /**
     * @description Método retorna a lista de bancos registrados no UiBsUtil
     */
    getBankList() {
        return this.banksService.getBankList();
    }
    /**
     * @description Método retorna a lista de bancos registrados no UiBsUtil
     */
    getBankListWithIspb() {
        return this.banksService.getBankListWithIspb();
    }
    /**
     * @description Método cria o form para ser utilizado no fluxo de transferência
     */
    createFormTransfer() {
        this.formTransfer = this.formBuilder.group({
            document: new FormControl('', Validators.compose([Validators.required, DocumentValidator.isValidCPFCNPJ, Validators.minLength(14)])),
            transferValue: new FormControl('', Validators.compose([Validators.required])),
            name: new FormControl('', Validators.compose([Validators.required, Validators.minLength(6), Validators.maxLength(60)])),
            branch: new FormControl('', Validators.compose([Validators.required, Validators.minLength(4), Validators.maxLength(4)])),
            accountNumber: new FormControl('', Validators.compose([Validators.required, Validators.minLength(3), Validators.maxLength(20)])),
            accountType: new FormControl('', Validators.compose([Validators.required])),
            bank: new FormControl('', Validators.compose([Validators.required])),
            bankCode: new FormControl(''),
            typeTransfer: new FormControl(''),
            uuidAccountPaymentDestination: new FormControl(''),
            uuidWhiteLabelDestination: new FormControl(''),
            uuidQrCodeOnUs: new FormControl(''),
            dateExecution: new FormControl(''),
            showRepeatOptions: new FormControl(''),
            frequency: new FormControl(''),
            occurrences: new FormControl('')
        });
        return this.formTransfer;
    }
    /**
     * @description Método recebe o form e transforma no corpo para o fluxo da transferência
     */
    prepareForm(form) {
        let data = form.getRawValue();
        let dataTransfer = new TransferResponse();
        dataTransfer.document = data.document;
        dataTransfer.transferValue = data.transferValue;
        dataTransfer.name = data.name;
        dataTransfer.bank = data.bank;
        dataTransfer.bankCode = data.bankCode;
        dataTransfer.branch = data.branch;
        dataTransfer.accountNumber = data.accountNumber;
        dataTransfer.accountType = data.accountType;
        dataTransfer.date = this.dateNow();
        dataTransfer.typeTransfer = data.typeTransfer;
        dataTransfer.dateExecution = data.dateExecution;
        dataTransfer.showRepeatOptions = data.showRepeatOptions;
        dataTransfer.frequency = data.frequency;
        dataTransfer.occurrences = data.occurrences;
        dataTransfer.uuidAccountPaymentDestination = data.uuidAccountPaymentDestination;
        dataTransfer.uuidWhiteLabelDestination = data.uuidWhiteLabelDestination;
        if (data.uuidQrCodeOnUs) {
            dataTransfer.uuidQrCodeOnUs = data.uuidQrCodeOnUs;
        }
        return dataTransfer;
    }
    /**
     * @description Método consulta o documento dentro do arranjo de pagamento
     */
    documentConsult(uuidWhiteLabel, document) {
        return __awaiter(this, void 0, void 0, function* () {
            let dataAccount;
            let documentNoFormat = document.replace(/[^\w\s]/gi, '');
            yield this.speJCashOutProxy
                .getAccountbydocument(uuidWhiteLabel, documentNoFormat)
                .toPromise()
                .then((res) => {
                dataAccount = res;
                if (dataAccount !== null) {
                    this.mountTransfer(dataAccount, document);
                }
            })
                .catch((err) => this.getErrorTransfer(err));
            let exist = !!dataAccount ? dataAccount : null;
            return Promise.resolve(exist);
        });
    }
    /**
     * @description Método preenche o form conforme o retorno da consulta por documento
     */
    mountTransfer(dataAccount, document) {
        this.formTransfer = this.formBuilder.group({
            document: new FormControl(document, Validators.compose([Validators.required, DocumentValidator.isValidCPFCNPJ, Validators.minLength(14)])),
            name: new FormControl(dataAccount.name, Validators.compose([Validators.required, Validators.minLength(6), Validators.maxLength(60)])),
            transferValue: new FormControl(dataAccount.transferValue, Validators.compose([Validators.required])),
            branch: new FormControl(dataAccount.bankBranch, Validators.compose([Validators.required, Validators.minLength(4), Validators.maxLength(4)])),
            accountNumber: new FormControl(dataAccount.bankAccount, Validators.compose([Validators.required, Validators.minLength(3), Validators.maxLength(20)])),
            accountType: new FormControl('CC', Validators.compose([Validators.required])),
            bank: new FormControl(dataAccount.bankName, Validators.compose([Validators.required])),
            bankCode: new FormControl('633'),
            typeTransfer: new FormControl('On-Us'),
            uuidAccountPaymentDestination: new FormControl(dataAccount.uuidAccountPayment),
            uuidWhiteLabelDestination: new FormControl(dataAccount.uuidWhiteLabel),
            uuidQrCodeOnUs: new FormControl(null),
        });
        this.setTransfer(this.formTransfer);
    }
    /**
     * @description Método retorna o form preenchido no processo de transferência
     */
    getFormTransfer() {
        let transferData;
        this.getTransfer().subscribe((res) => {
            transferData = res || {};
        });
        this.formTransfer = this.formBuilder.group({
            document: new FormControl(transferData.document, Validators.compose([Validators.required, DocumentValidator.isValidCPFCNPJ, Validators.minLength(14)])),
            transferValue: new FormControl(transferData.transferValue, Validators.compose([Validators.required])),
            name: new FormControl(transferData.name, Validators.compose([Validators.required, Validators.minLength(2), Validators.maxLength(60)])),
            branch: new FormControl(transferData.branch, Validators.compose([Validators.required, Validators.minLength(4), Validators.maxLength(5)])),
            accountNumber: new FormControl(transferData.accountNumber, Validators.compose([Validators.required, Validators.minLength(3), Validators.maxLength(20)])),
            accountType: new FormControl(transferData.accountType, Validators.compose([Validators.required])),
            bank: new FormControl(transferData.bank, Validators.compose([Validators.required])),
            bankCode: new FormControl(transferData.bankCode),
            typeTransfer: new FormControl(transferData.typeTransfer),
            uuidAccountPaymentDestination: new FormControl(transferData.uuidAccountPaymentDestination),
            uuidWhiteLabelDestination: new FormControl(transferData.uuidWhiteLabelDestination),
            uuidQrCodeOnUs: new FormControl(transferData.uuidQrCodeOnUs ? transferData.uuidQrCodeOnUs : null),
            dateExecution: new FormControl(transferData.dateExecution, Validators.compose([])),
            showRepeatOptions: new FormControl(transferData.showRepeatOptionsm, Validators.compose([])),
            frequency: new FormControl(transferData.frequency, Validators.compose([])),
            occurrences: new FormControl(transferData.occurrences, Validators.compose([]))
        });
        return this.formTransfer;
    }
    disabledToogle(formTransfer) {
        return (formTransfer.controls.document.valid &&
            formTransfer.controls.name.valid &&
            formTransfer.controls.branch.valid &&
            formTransfer.controls.accountNumber.valid &&
            formTransfer.controls.accountType.valid);
    }
    getErrorTransfer(error) {
        this.errorMessageService.getError(error);
    }
    getFormMessageError() {
        return this.errorMessages;
    }
    /**
     * @description Método retorna a data atual no formato dd/MM/aaaa
     */
    dateNow() {
        let data = new Date(), day = data.getDate().toString(), dayF = day.length == 1 ? '0' + day : day, month = (data.getMonth() + 1).toString(), monthF = month.length == 1 ? '0' + month : month, yearF = data.getFullYear();
        return dayF + '/' + monthF + '/' + yearF;
    }
    /**
     * @description Método responsavel por montar o corpo para envio e realiza a transferência
     */
    sendTransaction(uuidWhiteLabel, uuidAccount, token) {
        return __awaiter(this, void 0, void 0, function* () {
            let transferData;
            let sendingBody;
            let transferResponse;
            yield this.getTransfer().subscribe((res) => {
                transferData = res;
            });
            if (transferData.typeTransfer === 'TED') {
                sendingBody = {
                    accountType: transferData.accountType,
                    bankAccount: transferData.accountNumber.replace(/[^\w\s]/gi, ''),
                    bankBranch: transferData.branch,
                    bankCode: transferData.bankCode,
                    codeAuthorization: token,
                    codeOperation: '120',
                    document: transferData.document.replace(/[^\w\s]/gi, ''),
                    name: transferData.name,
                    operationValue: this.formatValue(transferData.transferValue),
                    uuidAccountPayment: uuidAccount,
                    uuidWhiteLabel: uuidWhiteLabel,
                    dateExecution: moment(transferData.dateExecution).format('YYYY-MM-DD').toString(),
                    showRepeatOptions: transferData.showRepeatOptions,
                    frequency: transferData.frequency,
                    occurrences: transferData.occurrences
                };
            }
            else {
                sendingBody = {
                    accountType: transferData.accountType,
                    bankAccount: transferData.accountNumber.replace(/[^\w\s]/gi, ''),
                    bankBranch: transferData.branch,
                    bankCode: transferData.bankCode,
                    codeAuthorization: token,
                    codeOperation: '901',
                    document: transferData.document.replace(/[^\w\s]/gi, ''),
                    name: transferData.name,
                    operationValue: transferData.typeTransfer.toUpperCase() === 'QRCODE-ON-US'
                        ? transferData.transferValue
                        : this.formatValue(transferData.transferValue),
                    uuidAccountPayment: uuidAccount,
                    uuidAccountPaymentDestination: transferData.uuidAccountPaymentDestination,
                    uuidWhiteLabel: uuidWhiteLabel,
                    uuidWhiteLabelDestination: transferData.uuidWhiteLabelDestination,
                    uuidQrCodeOnUs: transferData.uuidQrCodeOnUs ? transferData.uuidQrCodeOnUs : null,
                    dateExecution: moment(transferData.dateExecution).format('YYYY-MM-DD').toString(),
                    showRepeatOptions: transferData.showRepeatOptions,
                    frequency: transferData.frequency,
                    occurrences: transferData.occurrences
                };
            }
            yield this.speJCashOutProxy
                .effectTransfer(uuidWhiteLabel, sendingBody.document, sendingBody)
                .toPromise()
                .then((res) => {
                transferResponse = res;
                if (transferResponse.isExecuted === true) {
                    this.saveReceipt(transferResponse.result.transactionId);
                }
            })
                .catch((err) => this.getErrorTransfer(err));
            let response = !!transferResponse ? transferResponse : null;
            return Promise.resolve(response);
        });
    }
    /**
     * @description Método fomata o valor de string e retorna um float
     */
    formatValue(value) {
        let transferValue = String(value).replace(/\./g, '');
        let transferValue2 = transferValue.replace(',', '.');
        return parseFloat(transferValue2);
    }
    /**
     * @description Método salva os dados para impressaão do comprovante
     */
    saveReceipt(transactionId) {
        this.extractService.getTransaction(transactionId).subscribe((res) => {
            this.transferConfirmation.next(res);
        }, (err) => {
            console.error('Failed to load data', err);
        });
    }
    /**
     * @description Método responsavel por retornar os dados do comprovante de transferência
     */
    getTransferConfirmation() {
        return this.transferConfirmation.asObservable();
    }
    /**
     * @description Método de impressão.
     * @param html
     * @param css
     */
    print(html, css) {
        this.printService.print(html, css);
    }
    /**
     * @description Método reinicia os dados para o processo
     */
    unsubscribe() {
        this.behaviorTransfer = new BehaviorSubject(null);
        this.transferConfirmation = new BehaviorSubject(null);
        this.createFormTransfer();
    }
    /**
     * @description Método responsavel por validar a transferência
     */
    validateOperation(uuidWhiteLabel, uuidAccount) {
        return __awaiter(this, void 0, void 0, function* () {
            let transferData;
            let sendingBody;
            let validateResponse;
            yield this.getTransfer().subscribe((res) => {
                transferData = res;
            });
            if (transferData.typeTransfer === 'TED') {
                sendingBody = {
                    codeOperation: '120',
                    uuidAccountPayment: uuidAccount,
                    uuidWhiteLabel: uuidWhiteLabel,
                    valueOperation: this.formatValue(transferData.transferValue),
                };
            }
            else {
                sendingBody = {
                    codeOperation: '901',
                    uuidAccountPayment: uuidAccount,
                    uuidWhiteLabel: uuidWhiteLabel,
                    valueOperation: transferData.typeTransfer.toUpperCase() === 'QRCODE-ON-US'
                        ? transferData.transferValue
                        : this.formatValue(transferData.transferValue),
                };
            }
            yield this.speJCheckEventProxy
                .validateOperation(sendingBody)
                .toPromise()
                .then((res) => {
                validateResponse = res;
            })
                .catch((err) => this.getErrorTransfer(err));
            let response = !!validateResponse ? validateResponse : null;
            return Promise.resolve(response);
        });
    }
    /**
     * @description Metodo responsavel por encaminhar a hash do qrcode e coletar as informaçoes
     */
    consultQrcode(uuidAccountPaymentPay, encode) {
        return this.speNAccountsProxy.decodeQrcode(uuidAccountPaymentPay, encode);
    }
};
TransferService.ctorParameters = () => [
    { type: FormBuilder },
    { type: SpeJCashOutProxy },
    { type: SpeJCheckEventProxy },
    { type: SpeNAccountsProxy },
    { type: Storage },
    { type: ConfigService },
    { type: ErrorMessageService },
    { type: BanksService },
    { type: PrintService },
    { type: ExtractService }
];
TransferService = __decorate([
    Injectable()
], TransferService);

let TaxesTariffService = class TaxesTariffService extends BaseService {
    constructor(storage, configService, service) {
        super(storage, configService);
        this.storage = storage;
        this.configService = configService;
        this.service = service;
    }
    /**
     * retorna as informações de taxas e tarifas do wl informado
     * @param transationId
     */
    getTaxesTariff(uuidWl, uuidAccount) {
        return this.service.getTaxesTariff(uuidWl, uuidAccount);
    }
};
TaxesTariffService.ctorParameters = () => [
    { type: Storage },
    { type: ConfigService },
    { type: SpeViewNAccountProxy }
];
TaxesTariffService = __decorate([
    Injectable()
], TaxesTariffService);

let ClientLimitRateService = class ClientLimitRateService extends BaseService {
    constructor(storage, configService, service) {
        super(storage, configService);
        this.storage = storage;
        this.configService = configService;
        this.service = service;
    }
    /**
     * retorna as informações de limites do wl informado
     * @param transationId
     */
    getClientLimitRate(uuidWl, uuidAccountPayment) {
        return this.service.getClientLimitRate(uuidWl, uuidAccountPayment);
    }
};
ClientLimitRateService.ctorParameters = () => [
    { type: Storage },
    { type: ConfigService },
    { type: SpeViewNAccountProxy }
];
ClientLimitRateService = __decorate([
    Injectable()
], ClientLimitRateService);

class TransferPixResponse {
}

const PAYMENT_PIX_OPERATION = 1016;
const DEVOLUTION_PIX_OPERATION = 1017;
let PixService = class PixService extends BaseService {
    constructor(formBuilder, speJCheckEventProxy, speNAccountsProxy, speJCashOutProxy, storage, configService, errorMessageService, banksService, printService, extractService) {
        super(storage, configService);
        this.formBuilder = formBuilder;
        this.speJCheckEventProxy = speJCheckEventProxy;
        this.speNAccountsProxy = speNAccountsProxy;
        this.speJCashOutProxy = speJCashOutProxy;
        this.storage = storage;
        this.configService = configService;
        this.errorMessageService = errorMessageService;
        this.banksService = banksService;
        this.printService = printService;
        this.extractService = extractService;
        this.behaviorTransfer = new BehaviorSubject(null);
        this.TransferFlow = new BehaviorSubject('');
        this.transferConfirmation = new BehaviorSubject(null);
    }
    /**
     * @description Método registra o objeto com os dados já preenchidos no fluxo de transferência
     */
    setTransfer(form) {
        this.behaviorTransfer.next(this.prepareForm(form));
    }
    /**
     * @description Método retorna o objeto com os dados já preenchidos no fluxo de transferência
     */
    getTransfer() {
        return this.behaviorTransfer.asObservable();
    }
    /**
     * @description Método registra o tipo de transferência está sendo feita
     */
    setTransferFlow(transferType) {
        this.TransferFlow.next(transferType);
    }
    /**
     * @description Método retorna o tipo de transferência está sendo feita
     */
    getTransferFlow() {
        return this.TransferFlow;
    }
    /**
     * @description Método cria o form para ser utilizado no fluxo de transferência
     */
    createFormTransfer() {
        this.formTransfer = this.formBuilder.group({
            document: new FormControl(null, Validators.compose([])),
            personType: new FormControl(null, Validators.compose([])),
            name: new FormControl(null, Validators.compose([])),
            accountNumber: new FormControl(null, Validators.compose([])),
            accountType: new FormControl(null, Validators.compose([])),
            branch: new FormControl(null, Validators.compose([])),
            ispb: new FormControl(null, Validators.compose([])),
            key: new FormControl(null, Validators.compose([])),
            devolutionCode: new FormControl(null, Validators.compose([])),
            transactionIdCredit: new FormControl(null, Validators.compose([])),
            operationValue: new FormControl(null, Validators.compose([])),
            description: new FormControl(null, Validators.compose([])),
            pixDescription: new FormControl(null, Validators.compose([])),
            isCharged: new FormControl(null, Validators.compose([])),
            primaryDescription: new FormControl(null, Validators.compose([])),
            operationCode: new FormControl(null, Validators.compose([])),
            codeAuthorization: new FormControl(null, Validators.compose([])),
            transactionId: new FormControl(null, Validators.compose([])),
            uuidAccountPayment: new FormControl(null, Validators.compose([])),
            uuidWhiteLabel: new FormControl(null, Validators.compose([])),
            uuidPixDict: new FormControl(null, Validators.compose([])),
            txId: new FormControl(null, Validators.compose([])),
            dateExecution: new FormControl(null, Validators.compose([])),
            frequency: new FormControl(null, Validators.compose([])),
            occurrences: new FormControl(null, Validators.compose([]))
        });
        return this.formTransfer;
    }
    /**
     * @description Método recebe o form e transforma no corpo para o fluxo da transferência
     */
    prepareForm(form) {
        let data = form.getRawValue();
        let dataTransfer = new TransferPixResponse();
        dataTransfer.uuidAccountPayment = data.uuidAccountPayment;
        dataTransfer.uuidWhiteLabel = data.uuidWhiteLabel;
        dataTransfer.transactionId = data.transactionId;
        dataTransfer.codeAuthorization = data.codeAuthorization;
        dataTransfer.operationCode = data.operationCode;
        dataTransfer.primaryDescription = data.primaryDescription;
        dataTransfer.isCharged = data.isCharged;
        dataTransfer.operationValue = data.operationValue;
        dataTransfer.description = data.description;
        dataTransfer.pixDescription = data.pixDescription;
        dataTransfer.transactionIdCredit = data.transactionIdCredit;
        dataTransfer.devolutionCode = data.devolutionCode;
        dataTransfer.key = data.key;
        dataTransfer.ispb = data.ispb;
        dataTransfer.branch = data.branch;
        dataTransfer.accountType = data.accountType;
        dataTransfer.accountNumber = data.accountNumber;
        dataTransfer.name = data.name;
        dataTransfer.personType = data.personType;
        dataTransfer.document = data.document;
        dataTransfer.uuidPixDict = data.uuidPixDict;
        dataTransfer.txId = data.txId;
        dataTransfer.dateExecution = data.dateExecution;
        dataTransfer.frequency = data.frequency;
        dataTransfer.occurrences = data.occurrences;
        return dataTransfer;
    }
    /**
     * @description Método retorna o form preenchido no processo de transferência
     */
    getFormTransfer() {
        let transferData;
        this.getTransfer().subscribe((res) => {
            transferData = res;
        });
        this.formTransfer = this.formBuilder.group({
            document: new FormControl(transferData.document, Validators.compose([])),
            personType: new FormControl(transferData.personType, Validators.compose([])),
            name: new FormControl(transferData.name, Validators.compose([])),
            accountNumber: new FormControl(transferData.accountNumber, Validators.compose([])),
            accountType: new FormControl(transferData.accountType, Validators.compose([])),
            branch: new FormControl(transferData.branch, Validators.compose([])),
            ispb: new FormControl(transferData.ispb, Validators.compose([])),
            key: new FormControl(transferData.key, Validators.compose([])),
            devolutionCode: new FormControl(transferData.devolutionCode, Validators.compose([])),
            transactionIdCredit: new FormControl(transferData.transactionIdCredit, Validators.compose([])),
            operationValue: new FormControl(transferData.operationValue, Validators.compose([])),
            description: new FormControl(transferData.description, Validators.compose([])),
            pixDescription: new FormControl(transferData.pixDescription, Validators.compose([])),
            isCharged: new FormControl(transferData.isCharged, Validators.compose([])),
            primaryDescription: new FormControl(transferData.primaryDescription, Validators.compose([])),
            operationCode: new FormControl(transferData.operationCode, Validators.compose([])),
            codeAuthorization: new FormControl(transferData.codeAuthorization, Validators.compose([])),
            transactionId: new FormControl(transferData.transactionId, Validators.compose([])),
            uuidAccountPayment: new FormControl(transferData.uuidAccountPayment, Validators.compose([])),
            uuidWhiteLabel: new FormControl(transferData.uuidWhiteLabel, Validators.compose([])),
            uuidPixDict: new FormControl(transferData.uuidPixdict, Validators.compose([])),
            txId: new FormControl(transferData.txId, Validators.compose([])),
            dateExecution: new FormControl(transferData.dateExecution, Validators.compose([])),
            frequency: new FormControl(transferData.frequency, Validators.compose([])),
            occurrences: new FormControl(transferData.occurrences, Validators.compose([]))
        });
        return this.formTransfer;
    }
    getErrorTransfer(error) {
        this.errorMessageService.getError(error);
    }
    /**
     * @description Método retorna a data atual no formato dd/MM/aaaa
     */
    dateNow() {
        let data = new Date(), day = data.getDate().toString(), dayF = day.length == 1 ? '0' + day : day, month = (data.getMonth() + 1).toString(), monthF = month.length == 1 ? '0' + month : month, yearF = data.getFullYear();
        return dayF + '/' + monthF + '/' + yearF;
    }
    /**
     * @description Método responsavel por montar o corpo para envio e realiza a transferência
     */
    sendTransaction(token) {
        return __awaiter(this, void 0, void 0, function* () {
            let transferData;
            let sendingBody;
            let transferResponse;
            yield this.getTransfer().subscribe((res) => {
                transferData = res;
            });
            sendingBody = {
                uuidAccountPayment: transferData.uuidAccountPayment,
                uuidWhiteLabel: transferData.uuidWhiteLabel,
                transactionId: transferData.transactionId,
                codeAuthorization: token,
                operationCode: transferData.operationCode,
                primaryDescription: transferData.primaryDescription,
                isCharged: transferData.isCharged,
                operationValue: transferData.operationValue,
                description: transferData.description,
                pixDescription: transferData.pixDescription,
                transactionIdCredit: transferData.transactionIdCredit,
                devolutionCode: transferData.devolutionCode,
                key: transferData.key,
                ispb: transferData.ispb,
                branch: transferData.branch,
                accountType: transferData.accountType,
                accountNumber: transferData.accountNumber,
                name: transferData.name,
                personType: transferData.personType,
                document: transferData.document,
                uuidPixDict: transferData.uuidPixDict,
                txId: transferData.txId,
                dateExecution: transferData.dateExecution,
                frequency: transferData.frequency,
                occurrences: transferData.occurrences
                // userId: '422217c1-d118-4852-a293-13c96e495c61'
            };
            if (transferData.devolutionCode) {
                sendingBody.operationCode = DEVOLUTION_PIX_OPERATION;
            }
            else {
                sendingBody.operationCode = PAYMENT_PIX_OPERATION;
            }
            yield this.speJCashOutProxy
                .pixTransaction(sendingBody)
                .toPromise()
                .then((res) => {
                transferResponse = res;
                if (transferResponse.isExecuted === true) {
                    this.saveReceipt(transferResponse.result.transactionId);
                }
            })
                .catch((err) => this.getErrorTransfer(err));
            let response = !!transferResponse ? transferResponse : null;
            return Promise.resolve(response);
        });
    }
    /**
     * @description Método salva os dados para impressaão do comprovante
     */
    saveReceipt(transactionId) {
        this.extractService.getTransaction(transactionId).subscribe((res) => {
            this.transferConfirmation.next(res);
        }, (err) => {
            console.error('Failed to load data', err);
        });
    }
    /**
     * @description Método responsavel por retornar os dados do comprovante de transferência
     */
    getTransferConfirmation() {
        return this.transferConfirmation.asObservable();
    }
    /**
     * @description Método de impressão.
     * @param html
     * @param css
     */
    print(html, css) {
        this.printService.print(html, css);
    }
    /**
     * @description Método reinicia os dados para o processo
     */
    unsubscribe() {
        this.behaviorTransfer = new BehaviorSubject(null);
        this.transferConfirmation = new BehaviorSubject(null);
        this.createFormTransfer();
    }
    /**
     * @description Método responsavel por validar a transferência
     */
    validateOperation() {
        return __awaiter(this, void 0, void 0, function* () {
            let transferData;
            let sendingBody;
            let validateResponse;
            yield this.getTransfer().subscribe((res) => {
                transferData = res;
            });
            if (transferData.devolutionCode)
                sendingBody = {
                    codeOperation: DEVOLUTION_PIX_OPERATION,
                    uuidAccountPayment: transferData.uuidAccountPayment,
                    uuidWhiteLabel: transferData.uuidWhiteLabel,
                    valueOperation: transferData.operationValue,
                };
            else {
                sendingBody = {
                    codeOperation: PAYMENT_PIX_OPERATION,
                    uuidAccountPayment: transferData.uuidAccountPayment,
                    uuidWhiteLabel: transferData.uuidWhiteLabel,
                    valueOperation: transferData.operationValue,
                };
            }
            yield this.speJCheckEventProxy
                .validateOperation(sendingBody)
                .toPromise()
                .then((res) => {
                validateResponse = res;
            })
                .catch((err) => this.getErrorTransfer(err));
            let response = !!validateResponse ? validateResponse : null;
            return Promise.resolve(response);
        });
    }
    /**
     * @description Metodo responsavel por encaminhar a hash do qrcode e coletar as informaçoes
     */
    consultQrcode(uuidAccountPaymentPay, encode) {
        return this.speNAccountsProxy.decodeQrcode(uuidAccountPaymentPay, encode);
    }
};
PixService.ctorParameters = () => [
    { type: FormBuilder },
    { type: SpeJCheckEventProxy },
    { type: SpeNAccountsProxy },
    { type: SpeJCashOutProxy },
    { type: Storage },
    { type: ConfigService },
    { type: ErrorMessageService },
    { type: BanksService },
    { type: PrintService },
    { type: ExtractService }
];
PixService = __decorate([
    Injectable()
], PixService);

let TransactionApprovalService = class TransactionApprovalService extends BaseService {
    constructor(speNTransactionApprovalProxy, storage, configService) {
        super(storage, configService);
        this.speNTransactionApprovalProxy = speNTransactionApprovalProxy;
        this.storage = storage;
        this.configService = configService;
    }
    /**
     * @description Método que lista transações a serem aprovadas
     */
    getTransactions(uuidAccountPayment, uuidWhiteLabel, params) {
        return this.speNTransactionApprovalProxy.getTransactions(uuidAccountPayment, uuidWhiteLabel, params);
    }
    /**
     * @description Método para aprovação das transações selecionadas
     */
    approveTransactions(uuidAccountPayment, payload) {
        return this.speNTransactionApprovalProxy.approveTransactions(uuidAccountPayment, payload);
    }
    rejectTransactions(uuidAccountPayment, payload) {
        return this.speNTransactionApprovalProxy.rejectTransactions(uuidAccountPayment, payload);
    }
};
TransactionApprovalService.ctorParameters = () => [
    { type: SpeNTransactionApprovalProxy },
    { type: Storage },
    { type: ConfigService }
];
TransactionApprovalService = __decorate([
    Injectable()
], TransactionApprovalService);

var UiBsCashOutModule_1;
let UiBsCashOutModule = UiBsCashOutModule_1 = class UiBsCashOutModule {
    constructor(parentModule) {
        //...
    }
    static forRoot(config) {
        return {
            ngModule: UiBsCashOutModule_1,
            providers: [{ provide: APP_PARAMETER, useValue: config }],
        };
    }
};
UiBsCashOutModule.ctorParameters = () => [
    { type: UiBsCashOutModule, decorators: [{ type: Optional }, { type: SkipSelf }] }
];
UiBsCashOutModule = UiBsCashOutModule_1 = __decorate([
    NgModule({
        declarations: [],
        imports: [
            CommonModule,
            FormsModule,
            IonicModule,
            IonicStorageModule.forRoot({
                driverOrder: ['indexeddb', 'sqlite', 'websql'],
            }),
            UiPxCashOutModule,
        ],
        providers: [
            TransferService,
            BilletService,
            ExtractDigitalAccountService,
            ExtractService,
            AddCardService,
            AccountDataService,
            TaxesTariffService,
            ClientLimitRateService,
            PixService,
            TransactionApprovalService,
        ],
        exports: [RxReactiveFormsModule],
    }),
    __param(0, Optional()), __param(0, SkipSelf())
], UiBsCashOutModule);

class BilletResponse {
}

class DataFormatBilletResponse {
}

class DataFormatSaveBilletResponse {
}

class DataStatementResponse {
}

class AccountPaymentPersonResponse {
}

class ClientLimitRateResponse {
}

/*
 * Public API Surface of ui-bs-cashout
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AccountDataService, AccountPaymentPersonResponse, AddCardResponse, AddCardService, BilletResponse, BilletService, ClientLimitRateResponse, ClientLimitRateService, DataFormatBilletResponse, DataFormatSaveBilletResponse, DataStatementResponse, ExtractDigitalAccountResponse, ExtractDigitalAccountService, ExtractService, PixService, TaxesTariffService, TransactionApprovalService, TransferResponse, TransferService, UiBsCashOutModule };
//# sourceMappingURL=wlp-ui-bs-cashout.js.map
